// Central content + translations. Edit pricing / schedule / text here.
// Structure ready for more languages (es, de, it) — just add a new key.

export const LESSONS = [
  {
    id: "beginner_group",
    price: 35,
    unit: "person",
    duration: "1.5h",
    group: "6 max",
    level: "beginner",
    image:
      "https://images.unsplash.com/photo-1502680390469-be75c86b636f?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "private",
    price: 60,
    unit: "person",
    duration: "1.5h",
    group: "1-on-1",
    level: "all",
    image:
      "https://images.pexels.com/photos/6737856/pexels-photo-6737856.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "package",
    price: 250,
    unit: "person",
    duration: "5 days",
    group: "8 max",
    level: "all",
    image:
      "https://images.unsplash.com/photo-1531722569936-825d3dd91b15?auto=format&fit=crop&w=1200&q=80",
  },
];

export const SLOTS = [
  { id: "morning", time: "09:00 – 11:00" },
  { id: "afternoon", time: "14:00 – 16:00" },
  { id: "sunset", time: "17:30 – 19:00" },
];

export const GALLERY = [
  { src: "https://images.pexels.com/photos/36674324/pexels-photo-36674324.jpeg?auto=compress&cs=tinysrgb&w=1200", ratio: "aspect-[3/4]" },
  { src: "https://images.unsplash.com/photo-1551304885-277107370841?auto=format&fit=crop&w=1200&q=80", ratio: "aspect-[16/10]" },
  { src: "https://images.unsplash.com/photo-1662304087729-def43a9f5264?auto=format&fit=crop&w=1200&q=80", ratio: "aspect-[16/10]" },
  { src: "https://images.unsplash.com/photo-1503022932596-500eb8cca2d8?auto=format&fit=crop&w=1200&q=80", ratio: "aspect-[3/4]" },
  { src: "https://images.unsplash.com/photo-1502680390469-be75c86b636f?auto=format&fit=crop&w=1200&q=80", ratio: "aspect-[16/10]" },
  { src: "https://images.unsplash.com/photo-1531722569936-825d3dd91b15?auto=format&fit=crop&w=1200&q=80", ratio: "aspect-[3/4]" },
];

export const CONTACT = {
  whatsapp: "212662104229",
  whatsappDisplay: "+212 662 104 229",
  instagram: "https://www.instagram.com/atlasziztours",
  facebook: "https://www.facebook.com/profile.php?id=61592174715138",
  email: "atlasziztours.com@gmail.com",
  mapEmbed:
    "https://www.google.com/maps?q=Taghazout%20Beach%20Agadir%20Morocco&output=embed",
};

const TESTIMONIALS = {
  en: [
    { quote: "The best morning of our trip. Caught my first wave in 30 minutes — the instructors are unreal.", name: "Emma L.", from: "Paris, France" },
    { quote: "Booked a 5-day package. By day three I was riding green waves. Genuinely life-changing.", name: "Lukas M.", from: "Munich, Germany" },
    { quote: "Warm water, empty line-ups and a crew that treats you like family. Agadir is a hidden gem.", name: "Sofia R.", from: "Barcelona, Spain" },
    { quote: "Private lesson at sunset was pure magic. Professional, patient and so much fun.", name: "Giulia B.", from: "Milan, Italy" },
  ],
  fr: [
    { quote: "La meilleure matinée de notre voyage. Première vague en 30 minutes — les moniteurs sont incroyables.", name: "Emma L.", from: "Paris, France" },
    { quote: "Nous avons réservé un forfait 5 jours. Au troisième jour, je surfais déjà les vagues. Une expérience qui change une vie.", name: "Lukas M.", from: "Munich, Allemagne" },
    { quote: "Eau chaude, spots tranquilles et une équipe qui vous traite comme sa famille. Agadir est une pépite.", name: "Sofia R.", from: "Barcelone, Espagne" },
    { quote: "Le cours privé au coucher du soleil était magique. Professionnel, patient et tellement amusant.", name: "Giulia B.", from: "Milan, Italie" },
  ],
  ar: [
    { quote: "أفضل صباح في رحلتنا. ركبت أول موجة لي خلال 30 دقيقة — المدربون رائعون حقاً.", name: "إيما ل.", from: "باريس، فرنسا" },
    { quote: "حجزنا باقة 5 أيام. في اليوم الثالث كنت أركب الأمواج. تجربة غيّرت حياتي حقاً.", name: "لوكاس م.", from: "ميونخ، ألمانيا" },
    { quote: "مياه دافئة، أمواج هادئة وطاقم يعاملك كأنك من العائلة. أكادير جوهرة مخفية.", name: "صوفيا ر.", from: "برشلونة، إسبانيا" },
    { quote: "الدرس الخاص عند الغروب كان سحراً خالصاً. احترافي، صبور وممتع جداً.", name: "جوليا ب.", from: "ميلانو، إيطاليا" },
  ],
};

export const translations = {
  en: {
    nav: { about: "About", lessons: "Lessons", schedule: "Schedule", gallery: "Gallery", contact: "Contact", book: "Book Your Lesson", bookShort: "Book Now" },
    hero: {
      kicker: "Agadir · Morocco",
      line1: "Live the Surf",
      line2: "Experience",
      line3: "in Agadir",
      sub: "Warm Atlantic water, world-class waves and local instructors who grew up on this coast.",
      cta: "Book Your Lesson",
      secondary: "View Lessons",
    },
    marquee: "Beginner to Pro · Agadir Morocco · Authentic Surf Culture · Warm Water Year Round · ",
    about: {
      label: "Our Story",
      title: "Born from the Atlantic,\nguided by locals.",
      chapters: [
        { n: "01", t: "Rooted in Agadir", d: "Atlas Ziz Tours was founded by surfers born and raised on Morocco's golden coast. We know every peak, tide and sandbar from Taghazout to Anza." },
        { n: "02", t: "Certified local instructors", d: "Our team is ISA-minded, safety-first and fluent in the ocean. Small groups, real attention, and a stoke that's impossible to fake." },
        { n: "03", t: "A destination, not just a lesson", d: "300+ days of sun, warm water, and consistent swell. Agadir is one of the most beginner-friendly surf destinations on earth." },
      ],
    },
    lessons: {
      label: "Lessons & Packages",
      title: "Choose your wave.",
      sub: "Placeholder pricing — everything is easy to update later.",
      includes: "What's included",
      perPerson: "/ person",
      book: "Book this",
      features: ["Surfboard", "Wetsuit", "Certified instructor", "Insurance"],
      levelLabels: { beginner: "Beginner", all: "All levels" },
      names: {
        beginner_group: "Beginner Group Lesson",
        private: "Private Lesson · 1-on-1",
        package: "Surf Package · 5 Days",
      },
      descs: {
        beginner_group: "Perfect first taste of surfing in a fun, supportive group.",
        private: "One instructor, all yours — the fastest way to progress.",
        package: "Five days of coaching, video analysis and steady progression.",
      },
    },
    schedule: {
      label: "Weekly Schedule",
      title: "Three sessions.\nSeven days a week.",
      sub: "Sessions run daily, tide permitting. Reserve your spot below.",
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      slotNames: { morning: "Morning", afternoon: "Afternoon", sunset: "Sunset Session" },
      open: "Open",
    },
    booking: {
      label: "Reserve",
      title: "Book your session",
      sub: "Fill in the details and we'll confirm your spot.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      lesson: "Lesson type",
      date: "Date",
      pickDate: "Pick a date",
      slot: "Time slot",
      people: "Number of people",
      language: "Preferred language",
      notes: "Notes (optional)",
      submit: "Confirm Booking",
      submitting: "Booking...",
      successTitle: "You're booked!",
      successMsg: "Thanks {name} — your {lesson} on {date} ({slot}) is reserved. We'll be in touch shortly.",
      another: "Make another booking",
      required: "Please complete all required fields.",
      error: "Something went wrong. Please try again.",
    },
    gallery: { label: "Gallery", title: "From the water." },
    testimonials: { label: "Testimonials", title: "Loved by travellers." },
    contact: {
      label: "Find Us",
      title: "Come surf with us.",
      sub: "Taghazout Bay, just north of Agadir.",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Message sent! We'll reply soon.",
      whatsapp: "Chat on WhatsApp",
      follow: "Follow the journey",
    },
    footer: { tagline: "Surf school & tours · Agadir, Morocco", quick: "Explore", legal: "Legal", privacy: "Privacy Policy", terms: "Terms", rights: "All rights reserved.", big: "LET'S SURF" },
    slotTimes: { morning: "09:00 – 11:00", afternoon: "14:00 – 16:00", sunset: "17:30 – 19:00" },
    testimonialsData: TESTIMONIALS.en,
  },

  fr: {
    nav: { about: "À propos", lessons: "Cours", schedule: "Horaires", gallery: "Galerie", contact: "Contact", book: "Réserver un cours", bookShort: "Réserver" },
    hero: {
      kicker: "Agadir · Maroc",
      line1: "Vivez l'expérience",
      line2: "du surf",
      line3: "à Agadir",
      sub: "Eau atlantique chaude, vagues de classe mondiale et moniteurs locaux nés sur cette côte.",
      cta: "Réserver un cours",
      secondary: "Voir les cours",
    },
    marquee: "Débutant à Pro · Agadir Maroc · Culture surf authentique · Eau chaude toute l'année · ",
    about: {
      label: "Notre histoire",
      title: "Nés de l'Atlantique,\nguidés par les locaux.",
      chapters: [
        { n: "01", t: "Enracinés à Agadir", d: "Atlas Ziz Tours a été fondé par des surfeurs nés sur la côte dorée du Maroc. Nous connaissons chaque pic et chaque marée de Taghazout à Anza." },
        { n: "02", t: "Moniteurs locaux certifiés", d: "Notre équipe privilégie la sécurité et maîtrise l'océan. Petits groupes, vraie attention et une passion authentique." },
        { n: "03", t: "Une destination, pas qu'un cours", d: "300+ jours de soleil, eau chaude et houle régulière. Agadir est l'une des destinations les plus accueillantes pour débuter." },
      ],
    },
    lessons: {
      label: "Cours & Forfaits",
      title: "Choisissez votre vague.",
      sub: "Tarifs provisoires — tout est facile à modifier plus tard.",
      includes: "Inclus",
      perPerson: "/ personne",
      book: "Réserver",
      features: ["Planche", "Combinaison", "Moniteur certifié", "Assurance"],
      levelLabels: { beginner: "Débutant", all: "Tous niveaux" },
      names: {
        beginner_group: "Cours collectif débutant",
        private: "Cours privé · Individuel",
        package: "Forfait surf · 5 jours",
      },
      descs: {
        beginner_group: "Une première approche parfaite du surf dans un groupe convivial.",
        private: "Un moniteur rien que pour vous — la progression la plus rapide.",
        package: "Cinq jours de coaching, analyse vidéo et progression régulière.",
      },
    },
    schedule: {
      label: "Horaires hebdomadaires",
      title: "Trois sessions.\nSept jours sur sept.",
      sub: "Sessions quotidiennes selon les marées. Réservez votre place ci-dessous.",
      days: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
      slotNames: { morning: "Matin", afternoon: "Après-midi", sunset: "Coucher du soleil" },
      open: "Ouvert",
    },
    booking: {
      label: "Réserver",
      title: "Réservez votre session",
      sub: "Remplissez les détails et nous confirmerons votre place.",
      name: "Nom complet",
      email: "E-mail",
      phone: "Téléphone",
      lesson: "Type de cours",
      date: "Date",
      pickDate: "Choisir une date",
      slot: "Créneau horaire",
      people: "Nombre de personnes",
      language: "Langue préférée",
      notes: "Remarques (facultatif)",
      submit: "Confirmer la réservation",
      submitting: "Réservation...",
      successTitle: "C'est réservé !",
      successMsg: "Merci {name} — votre {lesson} le {date} ({slot}) est réservé. Nous vous contacterons bientôt.",
      another: "Faire une autre réservation",
      required: "Veuillez remplir tous les champs obligatoires.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
    },
    gallery: { label: "Galerie", title: "Depuis l'eau." },
    testimonials: { label: "Témoignages", title: "Adoré par les voyageurs." },
    contact: {
      label: "Nous trouver",
      title: "Venez surfer avec nous.",
      sub: "Baie de Taghazout, juste au nord d'Agadir.",
      name: "Nom",
      email: "E-mail",
      message: "Message",
      send: "Envoyer",
      sending: "Envoi...",
      success: "Message envoyé ! Nous répondrons bientôt.",
      whatsapp: "Discuter sur WhatsApp",
      follow: "Suivez l'aventure",
    },
    footer: { tagline: "École de surf & tours · Agadir, Maroc", quick: "Explorer", legal: "Légal", privacy: "Confidentialité", terms: "Conditions", rights: "Tous droits réservés.", big: "ON SURFE" },
    slotTimes: { morning: "09:00 – 11:00", afternoon: "14:00 – 16:00", sunset: "17:30 – 19:00" },
    testimonialsData: TESTIMONIALS.fr,
  },

  ar: {
    nav: { about: "من نحن", lessons: "الدروس", schedule: "المواعيد", gallery: "المعرض", contact: "اتصل بنا", book: "احجز درسك", bookShort: "احجز الآن" },
    hero: {
      kicker: "أكادير · المغرب",
      line1: "عِش تجربة",
      line2: "ركوب الأمواج",
      line3: "في أكادير",
      sub: "مياه أطلسية دافئة، أمواج عالمية المستوى ومدربون محليون نشأوا على هذا الساحل.",
      cta: "احجز درسك",
      secondary: "عرض الدروس",
    },
    marquee: "من المبتدئ إلى المحترف · أكادير المغرب · ثقافة ركوب أمواج أصيلة · مياه دافئة طوال العام · ",
    about: {
      label: "قصتنا",
      title: "وُلدنا من المحيط الأطلسي،\nيقودنا أبناء المنطقة.",
      chapters: [
        { n: "01", t: "متجذرون في أكادير", d: "تأسست Atlas Ziz Tours على يد راكبي أمواج وُلدوا ونشأوا على الساحل الذهبي للمغرب. نعرف كل موجة ومدّ من تغازوت إلى أنزا." },
        { n: "02", t: "مدربون محليون معتمدون", d: "فريقنا يضع السلامة أولاً ويتقن المحيط. مجموعات صغيرة، اهتمام حقيقي وشغف لا يمكن تزييفه." },
        { n: "03", t: "وجهة، وليست مجرد درس", d: "أكثر من 300 يوم مشمس، مياه دافئة وأمواج منتظمة. أكادير من أفضل الوجهات للمبتدئين في العالم." },
      ],
    },
    lessons: {
      label: "الدروس والباقات",
      title: "اختر موجتك.",
      sub: "الأسعار مؤقتة — كل شيء سهل التعديل لاحقاً.",
      includes: "ما يشمله",
      perPerson: "/ للشخص",
      book: "احجز هذا",
      features: ["لوح ركوب", "بدلة غوص", "مدرب معتمد", "تأمين"],
      levelLabels: { beginner: "مبتدئ", all: "جميع المستويات" },
      names: {
        beginner_group: "درس جماعي للمبتدئين",
        private: "درس خاص · فردي",
        package: "باقة ركوب الأمواج · 5 أيام",
      },
      descs: {
        beginner_group: "أفضل بداية لتجربة ركوب الأمواج في مجموعة ممتعة وداعمة.",
        private: "مدرب واحد لك وحدك — أسرع طريقة للتقدم.",
        package: "خمسة أيام من التدريب وتحليل الفيديو والتقدم المستمر.",
      },
    },
    schedule: {
      label: "المواعيد الأسبوعية",
      title: "ثلاث جلسات.\nسبعة أيام في الأسبوع.",
      sub: "الجلسات يومية حسب المد والجزر. احجز مكانك أدناه.",
      days: ["الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"],
      slotNames: { morning: "الصباح", afternoon: "بعد الظهر", sunset: "جلسة الغروب" },
      open: "متاح",
    },
    booking: {
      label: "احجز",
      title: "احجز جلستك",
      sub: "املأ التفاصيل وسنؤكد مكانك.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      lesson: "نوع الدرس",
      date: "التاريخ",
      pickDate: "اختر تاريخاً",
      slot: "الفترة الزمنية",
      people: "عدد الأشخاص",
      language: "اللغة المفضلة",
      notes: "ملاحظات (اختياري)",
      submit: "تأكيد الحجز",
      submitting: "جاري الحجز...",
      successTitle: "تم حجزك!",
      successMsg: "شكراً {name} — تم حجز {lesson} بتاريخ {date} ({slot}). سنتواصل معك قريباً.",
      another: "إجراء حجز آخر",
      required: "يرجى إكمال جميع الحقول المطلوبة.",
      error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    },
    gallery: { label: "المعرض", title: "من قلب الماء." },
    testimonials: { label: "آراء العملاء", title: "محبوب من المسافرين." },
    contact: {
      label: "موقعنا",
      title: "تعال لتركب الأمواج معنا.",
      sub: "خليج تغازوت، شمال أكادير مباشرة.",
      name: "الاسم",
      email: "البريد الإلكتروني",
      message: "الرسالة",
      send: "إرسال الرسالة",
      sending: "جاري الإرسال...",
      success: "تم إرسال الرسالة! سنرد قريباً.",
      whatsapp: "تحدث عبر واتساب",
      follow: "تابع الرحلة",
    },
    footer: { tagline: "مدرسة وجولات ركوب الأمواج · أكادير، المغرب", quick: "استكشف", legal: "قانوني", privacy: "سياسة الخصوصية", terms: "الشروط", rights: "جميع الحقوق محفوظة.", big: "لنركب الأمواج" },
    slotTimes: { morning: "09:00 – 11:00", afternoon: "14:00 – 16:00", sunset: "17:30 – 19:00" },
    testimonialsData: TESTIMONIALS.ar,
  },
};

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "ar", label: "ع", name: "العربية" },
];
